import React from "react";
import { Outlet } from "react-router-dom";
import TopBar from "./TopBar";
import { useApp } from "../context/AppContext";
import { Toaster } from "./ui/sonner";
import ChangePasswordDialog from "./ChangePasswordDialog";
import AskAiButton from "./AskAiButton";

export default function Layout() {
  const { loading, mustChangePassword } = useApp();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="flex items-center gap-3 text-slate-500">
          <div className="h-2.5 w-2.5 animate-pulse rounded-full bg-primary" />
          <span className="font-display text-sm">Loading OneDesk 360…</span>
        </div>
      </div>
    );
  }
  return (
    <div className="min-h-screen bg-background print:bg-white">
      <div className="print:hidden">
        <TopBar />
      </div>
      <main className="mx-auto max-w-[1400px] px-4 py-6 sm:px-6 sm:py-8 print:max-w-none print:p-0">
        <Outlet />
      </main>
      <Toaster richColors position="top-right" />
      {mustChangePassword && <ChangePasswordDialog forced />}
      {/* Floating AI assistant — hidden on print. Backend role-scopes data. */}
      <div className="print:hidden">
        <AskAiButton />
      </div>
    </div>
  );
}
